import { useEffect, useState } from "react";
import { Button, Dropdown, Segment } from "semantic-ui-react";
import DynamicTableComponent from "../DynamicTable/DynamicTableComponent";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react-lite";
import { ThreeDotLoader } from "../../app/layout/LoadingComponent";
import ReelSmarttrackerComponents from "./ReelSmarttrackerComponents";

const  ReelSmarttracker = () => {
    const { dashboardStore,TrackingReportStore,userStore } = useStore();
    const { reelSmartrackerSearchShow,reelSmarttracker,reelStatusUpdate,handleTitleCodeList,resetButtons,titleCode,showButton,reelSmarttrackerComponent } = TrackingReportStore;
    const [pageNumber,setPageNumber] = useState(0);
      useEffect(() => {
        handleTitleCodeList();
        // eslint-disable-next-line
      }, []);

      const statusButton = (status:string,statusNumber:number) => {

        const restorationPayload = {
          itemLevelId: reelSmarttrackerComponent?.id,
          taskId: reelSmarttrackerComponent?.id,
          taskName: 'Restoration',
          subTaskId: reelSmarttrackerComponent?.id,
          subTaskName: reelSmarttrackerComponent.current_SubTask,
          currentUser: userStore?.user?.displayName,
          actionName: statusNumber.toString() || '',
          titleStatus: reelSmarttrackerComponent.title_Status || ''
      };

        TrackingReportStore.reelSmarttracker.isModel = false;
        TrackingReportStore.isSmartTrackerButtonLoading = true;
        resetButtons();
        reelStatusUpdate(status,restorationPayload);
      }
      const paginateFunction = (e: number) => {
        reelSmartrackerSearchShow(titleCode.value,reelSmarttracker.selectedSubtask)
        dashboardStore.setReportsPageNum(e);
        setPageNumber(e)
      }
      const searchFunction = (column: any, order: any) => {
        console.log(order, column);
      };
  return (
    <>
      <Segment style={{ padding: '5px',height: '47px',display:'flex',justifyContent:'space-between' }}>
        
             <Dropdown
                downward
                clearable
                options={titleCode?.list || []}
                selection
                search
                placeholder="Please select the title code"
                onChange={(e: any, data1: any) => {
                TrackingReportStore.titleCode.value = data1.value;
                reelSmartrackerSearchShow(data1.value || '',reelSmarttracker.selectedSubtask || '');
                }}
                value={titleCode?.value || ''}
            />
            <div>
            {TrackingReportStore.isSmartTrackerButtonLoading ? (
              <div
                style={{ position: 'relative', width: '40px', height: '48px' }}
              >
                <ThreeDotLoader />
              </div>
            ) : (
              <>
                {showButton.start && (
                  <Button onClick={() => statusButton('started',1)} color="blue">
                    Start
                  </Button>
                )}
                {showButton.complete && (
                  <Button.Group floated="right">
                    <Button color="blue" onClick={() => statusButton('completed',2)}>
                      {' '}
                      Complete{' '}
                    </Button>
                    <Button.Or />
                    <Button
                      color="yellow"
                      //openHold
                      onClick={() => statusButton('hold',3)}
                    >
                      {' '}
                      Hold
                    </Button>
                    {/* <Button.Or />
                    <Button color="red" onClick={() => statusButton('rejected')}>
                      Reject
                    </Button> */}
                  </Button.Group>
                )}

                {showButton.Resume === true && (
                  <Button onClick={() => statusButton('resumed',4)}> Resume </Button>
                )}
              </>
            )}
            </div>
        </Segment> 
            <DynamicTableComponent data={reelSmarttracker.tableData || []} name={'Reel Smarttracker'} actiontype={""} pageFunc={paginateFunction} pageNumData={pageNumber} searchFuncData={searchFunction} loading={reelSmarttracker.loader}/>
     {TrackingReportStore.reelSmarttracker.isModel && <ReelSmarttrackerComponents/>}
      </>
  )
}

export default observer(ReelSmarttracker)

